import Script from "next/script";

const MicrosoftClarity = () => {
  const env = process.env.NEXT_PUBLIC_ENV;
  return (
    <>
      {env === "production" && (
        <Script id="clarity-script" strategy="lazyOnload">
          {`
						(function(c,l,a,r,i,t,y){
							c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
							t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
							y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
						})(window, document, "clarity", "script", "gxlypqpyub");
					`}
        </Script>
      )}
    </>
  );
};

export default MicrosoftClarity;
